import React from "react";
import { IconType } from "../../type/icon_type";

const ResetIcon = ({ width, height, color }: IconType) => {
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      stroke={color}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12C5 13.3845 5.41054 14.7378 6.17971 15.889C6.94888 17.0401 8.04213 17.9373 9.32121 18.4672C10.6003 18.997 12.0078 19.1356 13.3656 18.8655C14.7235 18.5954 15.9708 17.9287 16.9497 16.9497C17.9287 15.9708 18.5954 14.7235 18.8655 13.3656C19.1356 12.0078 18.997 10.6003 18.4672 9.32121C17.9373 8.04213 17.0401 6.94888 15.889 6.17971C14.7378 5.41054 13.3845 5 12 5C10.0431 5.00736 8.16475 5.77095 6.75778 7.13111"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5V8H9"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ResetIcon;
